<h2 mat-dialog-title>Save Progress</h2>

  <mat-dialog-content>
    <div class="dialog-content-container" [class.min-height]="isInvalidPasswordPattern()">
    @if(!isSaving){

        <form [formGroup]="saveForm">
          
          <app-text-input 
            [label]="'Email'" 
            [control]="saveForm.controls.email">
          </app-text-input>
        
          <app-text-input 
            [label]="'Confirm Email'" 
            [control]="saveForm.controls.repeatEmail">
          </app-text-input>
          <app-password-input
            [autocomplete]="'new-password'"
            [label]="'Password'"
            [control]="saveForm.controls.password">
          </app-password-input>

        </form>

  }
  @else {
    <div class="d-flex justify-content-center">
        <mat-spinner></mat-spinner>
    </div>
  }
  
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
     @if(!isSaving){
      <button mat-flat-button class="cancel-button" mat-dialog-close type="button" >Close</button>
      <button mat-flat-button type="button" (click)="saveClick()">OK</button>
     }
    </mat-dialog-actions>
